import React from 'react';
import styles from './Hero.module.css';
import logo from '../assets/puma.png';

const Hero = ({ hasNextGame }) => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className={styles.hero}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <img src={logo} alt="Pumy Betonu" className={styles.logo} />
        <h1 className={styles.headline}>
          WE DON'T REBUILD.<br />
          WE POUR CONCRETE.
        </h1>
        <p className={styles.sub}>PUMY BETONU — Liga WBA</p>
        {hasNextGame ? (
          <button
            className="cta-btn"
            onClick={() => scrollTo('next-game')}
          >
            SEE NEXT GAME
          </button>
        ) : (
          <button
            className="cta-btn"
            onClick={() => scrollTo('contact')}
          >
            CONTACT YOUR LOCAL PUMA FOR A DATE
          </button>
        )}
      </div>
    </section>
  );
};

export default Hero;
